import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  List,
  ListItem,
  ListItemText,
  Button
} from '@mui/material';
import AdvertisingLayout from '../../layouts/AdvertisingLayout';

// Import Premium Ad images
import premiumAd1 from '../../assets/Sales/Premium/Austnews Text Premium.jpg';
import premiumAd2 from '../../assets/Sales/Premium/Carindale Family Dentist 317160-1.jpg';
import premiumAd3 from '../../assets/Sales/Premium/Happy Hearts Child Care & Kindergarten - Albany Creek 317187-1.jpg';
import premiumAd4 from '../../assets/Sales/Premium/Place Estate Agents - Albany Creek-315834-6.jpg';
import premiumAd5 from '../../assets/Sales/Premium/Trinity Learning Centre 316580-Premium.jpg';

// Import Standard Ad images
import standardAd1 from '../../assets/Sales/Standard/316963-Standard-Kinetic-Education.jpg';
import standardAd2 from '../../assets/Sales/Standard/A Brighter Beginning 317609-1.jpg';
import standardAd3 from '../../assets/Sales/Standard/Body-Strong-Transformation-Centre-316740-Standard-1.jpg';
import standardAd4 from '../../assets/Sales/Standard/Emerge Realty 316955-2.jpg';
import standardAd5 from '../../assets/Sales/Standard/Step-In-Time-Talent-Studio-316680-2.jpg';
import standardAd6 from '../../assets/Sales/Standard/Supagas 30613-1.jpg';

// Import Budget Ad images
import budgetAd1 from '../../assets/Sales/Budget/283408-4-Accurate-Tree-Services.jpg';
import budgetAd2 from '../../assets/Sales/Budget/286848-3-Mackay Transit Coaches.jpg';
import budgetAd3 from '../../assets/Sales/Budget/305722-Brisbane Castle Hire-268308-N1501-eNewsletters.jpg';
import budgetAd4 from '../../assets/Sales/Budget/305814-Tamborine Mountain Auto Clinic-264547-N1501-eNewsletters.jpg';
import budgetAd5 from '../../assets/Sales/Budget/309170-Sunnybank Medical Centre-264705-N1501-eNewsletters.jpg';
import budgetAd6 from '../../assets/Sales/Budget/309819-3-Tec-NQ.jpg';
import budgetAd7 from '../../assets/Sales/Budget/313157-Tamborine Mountain Dance Academy-264733-N1501-eNewsletters.jpg';
import budgetAd8 from '../../assets/Sales/Budget/315762-1-Pats Gems.jpg';
import budgetAd9 from '../../assets/Sales/Budget/316733-AAA Brisbane North Driving School-268231-N1501-eNewsletters.jpg';
import budgetAd10 from '../../assets/Sales/Budget/316744-Humphrey Motors-268323-N1501-eNewsletters.jpg';
import budgetAd11 from '../../assets/Sales/Budget/316749-DH Cleaning Solutions-268380-N1501-eNewsletters.jpg';
import budgetAd12 from '../../assets/Sales/Budget/AiryFairys.JPG';
import budgetAd13 from '../../assets/Sales/Budget/Calamvale-Healthsave-Pharmacy-309344-Budget-2.jpg';
import budgetAd14 from '../../assets/Sales/Budget/Elite-Dance-Academy-295006-Budget-1.jpg';
import budgetAd15 from '../../assets/Sales/Budget/M Dance 316691-1.jpg';
import budgetAd16 from '../../assets/Sales/Budget/Mary-MacKillop-College310699-Budget-4.jpg';
import budgetAd17 from '../../assets/Sales/Budget/Tadpoles-Early-Learning-Centre-316002-Budget-1.jpg';

// Import Top Spot images
import topSpot1 from '../../assets/Sales/Top Spot/316879-Bundall Child Care Centre-269590-N1501-eNewsletters.gif';
import topSpot2 from '../../assets/Sales/Top Spot/316963-Premium-Kinetic-Education.jpg';
import topSpot3 from '../../assets/Sales/Top Spot/Mirani-Medical-Centre-311859-Premium-1.jpg';
import topSpot4 from '../../assets/Sales/Top Spot/Oracare Cleveland Dental & Facial Aesthetics 316874.jpg';

// Import Animated Ad images
import animatedAd1 from '../../assets/Sales/Animated/AthleticHub.gif';
import animatedAd2 from '../../assets/Sales/Animated/DanceStreet.gif';
import animatedAd3 from '../../assets/Sales/Animated/Kids-Entertainment-Ad-Example.gif';
import animatedAd4 from '../../assets/Sales/Animated/NoLimits.gif';
import animatedAd5 from '../../assets/Sales/Animated/ThePit.gif';

// Import POW images
import powAd1 from '../../assets/Sales/POW/316693-Inferno Cheer & Dance-268612-N1501-eNewsletters.jpg';
import powAd2 from '../../assets/Sales/POW/316708-Dance 22-268071-N1501-eNewsletters.jpg';
import powAd3 from '../../assets/Sales/POW/AffordableDrivingSchool.png';
import powAd4 from '../../assets/Sales/POW/Blue-Mountains-Tae-Kwon-Do-01.jpg';
import powAd5 from '../../assets/Sales/POW/POW-Dance-Sign-On-Ad-Examp-le.gif';
import powAd6 from '../../assets/Sales/POW/TAFE-Queensland-316289-Premium-2.jpg';

// Import Extras Icon images
import topSpotIcon from '../../assets/Sales/Top Spot.png';
import standOutMoreIcon from '../../assets/Sales/Stand Out More.png';
import powIcon from '../../assets/Sales/pow.png';

const ArtworkSpecs = () => {
  const navigate = useNavigate();
  
  const adSizes = [
    {
      title: 'Premium Ad',
      width: '93 mm',
      height: '103 mm',
      description: 'Our premium advertisement size offers maximum visibility and impact.',
      images: [premiumAd1, premiumAd2, premiumAd3, premiumAd4, premiumAd5]
    },
    {
      title: 'Standard Ad',
      width: '93 mm',
      height: '68 mm',
      description: 'The standard size provides excellent value and visibility.',
      images: [standardAd1, standardAd2, standardAd3, standardAd4, standardAd5, standardAd6]
    },
    {
      title: 'Budget Ad',
      width: '93 mm',
      height: '33 mm',
      description: 'An affordable option to get your message across effectively.',
      images: [budgetAd1, budgetAd2, budgetAd3, budgetAd4, budgetAd5, budgetAd6, budgetAd7, budgetAd8, budgetAd9, budgetAd10, budgetAd11, budgetAd12, budgetAd13, budgetAd14, budgetAd15, budgetAd16, budgetAd17]
    }
  ];

  // State for current image index for each ad size
  const [currentImageIndices, setCurrentImageIndices] = useState([0, 0, 0]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Auto-rotate images every 10 seconds with staggered delays
  useEffect(() => {
    const timers = adSizes.map((adSize, sizeIndex) => {
      // Stagger the start: Premium (0ms), Standard (1000ms), Budget (2000ms)
      const initialDelay = sizeIndex * 1000;
      
      const timeoutId = setTimeout(() => {
        const intervalId = setInterval(() => {
          // Don't rotate if this ad is being hovered
          if (hoveredIndex === sizeIndex) return;
          
          setCurrentImageIndices(prev => {
            const newIndices = [...prev];
            newIndices[sizeIndex] = (newIndices[sizeIndex] + 1) % adSize.images.length;
            return newIndices;
          });
        }, 10000);
        
        // Store the interval ID so we can clear it later
        timers[sizeIndex] = { timeout: null, interval: intervalId };
      }, initialDelay);
      
      return { timeout: timeoutId, interval: null };
    });

    return () => {
      timers.forEach(timer => {
        if (timer.timeout) clearTimeout(timer.timeout);
        if (timer.interval) clearInterval(timer.interval);
      });
    };
  }, [hoveredIndex, adSizes.length]);

  const extras = [
    {
      title: 'Top Spot',
      subtitle: 'Top Spot Exclusive',
      description: 'This prime piece of advertising real estate is open for booking with Standard, Premium and Premium+ campaigns. Get in quick though, there is only one position per newsletter.',
      icon: topSpotIcon,
      images: [topSpot1, topSpot2, topSpot3, topSpot4],
      link: '/advertising/top-spot'
    },
    {
      title: 'Animate your Ad',
      subtitle: 'Stand Out More',
      description: 'Make your ad stand out by adding animation and movement to your Premium Ad; upgrade to a Premium Plus (GIF) format. Our animated ads are perfect for grabbing your audience\'s immediate attention.',
      icon: standOutMoreIcon,
      images: [animatedAd1, animatedAd2, animatedAd3, animatedAd4, animatedAd5],
      link: '/advertising/animation'
    },
    {
      title: 'Campaign Booster',
      subtitle: 'POW',
      description: 'Our 5 week Premium Advertisement is perfect to boost your product, service, sale, event or special offer via digital school newsletters.',
      icon: powIcon,
      images: [powAd1, powAd2, powAd3, powAd4, powAd5, powAd6],
      link: '/advertising/pow'
    }
  ];

  // State for extras image rotation
  const [currentExtrasIndices, setCurrentExtrasIndices] = useState([0, 0, 0]);
  const [hoveredExtrasIndex, setHoveredExtrasIndex] = useState(null);

  // Auto-rotate extras images every 10 seconds with staggered delays
  useEffect(() => {
    const timers = extras.map((extra, extraIndex) => {
      // Stagger the start: Top Spot (0ms), Animate (1000ms), POW (2000ms)
      const initialDelay = extraIndex * 1000;
      
      const timeoutId = setTimeout(() => {
        const intervalId = setInterval(() => {
          // Don't rotate if this extra is being hovered
          if (hoveredExtrasIndex === extraIndex) return;
          
          setCurrentExtrasIndices(prev => {
            const newIndices = [...prev];
            newIndices[extraIndex] = (newIndices[extraIndex] + 1) % extra.images.length;
            return newIndices;
          });
        }, 10000);
        
        // Store the interval ID so we can clear it later
        timers[extraIndex] = { timeout: null, interval: intervalId };
      }, initialDelay);
      
      return { timeout: timeoutId, interval: null };
    });

    return () => {
      timers.forEach(timer => {
        if (timer.timeout) clearTimeout(timer.timeout);
        if (timer.interval) clearInterval(timer.interval);
      });
    };
  }, [hoveredExtrasIndex, extras.length]);

  const imageFileRequirements = [
    'We accept artwork supplied in image formats',
    'Please ensure image files are high resolution and meet the requirements for detail and depth',
    'Our recommended resolution for images is between 300-600dpi',
    'These can be supplied in JPG (.jpg or .jpeg) and PNG (.png)'
  ];

  const acceptedFormats = [
    'Adobe Acrobat (.pdf) - preferred',
    'Adobe Illustrator (.ai or .eps)',
    'Adobe InDesign (.indd)',
    'Adobe Photoshop (.psd)',
    'High resolution JPG (.jpg or .jpeg)',
    'High resolution PNG (.png)'
  ];

  return (
    <AdvertisingLayout>
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #247AA8 0%, #1E6A92 100%)',
          color: 'white',
          py: 8
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '3rem' }
            }}
          >
            Austnews Artwork Specs
          </Typography>
          <Typography
            variant="h5"
            sx={{
              mb: 4,
              fontWeight: 300
            }}
          >
            Advertisement Sizes & Requirements
          </Typography>
        </Container>
      </Box>

      {/* Advertisement Sizes */}
      <Box sx={{ py: 8, backgroundColor: 'linear-gradient(180deg, #E8F4F8 0%, #FFFFFF 100%)' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 6, fontWeight: 600, color: '#333132' }}>
            Advertisement Sizes
          </Typography>
          
          <Grid container spacing={4} justifyContent="center">
            {adSizes.map((ad, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Box sx={{ textAlign: 'center' }}>
                  {/* Ad Title Button */}
                  <Box
                    sx={{
                      backgroundColor: '#247AA8',
                      color: 'white',
                      py: 2,
                      px: 3,
                      borderRadius: '8px 8px 0 0',
                      fontWeight: 600,
                      fontSize: '1.25rem'
                    }}
                  >
                    {ad.title}
                  </Box>
                  
                  {/* Dimensions */}
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      py: 2,
                      borderLeft: '1px solid #ddd',
                      borderRight: '1px solid #ddd',
                      fontWeight: 600,
                      color: '#333132'
                    }}
                  >
                    {ad.width} (w) × {ad.height} (h)
                  </Box>
                  
                  {/* Image Display */}
                  <Box
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    sx={{
                      backgroundColor: 'white',
                      p: 2,
                      border: '1px solid #ddd',
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.05)'
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src={ad.images[currentImageIndices[index]]}
                      alt={`${ad.title} example`}
                      sx={{
                        maxWidth: '100%',
                        height: 'auto',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Extras */}
      <Box sx={{ py: 8, backgroundColor: 'linear-gradient(180deg, #E8F4F8 0%, #FFFFFF 100%)' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 6, fontWeight: 600, color: '#333132' }}>
            Extras
          </Typography>
          
          <Grid container spacing={4}>
            {extras.map((extra, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Paper
                  elevation={3}
                  sx={{
                    overflow: 'hidden',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: 6
                    }
                  }}
                >
                  {/* Icon Image Section */}
                  <Box
                    sx={{
                      background: 'linear-gradient(135deg, #E8F4F8 0%, #B8D9E8 100%)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      py: 4,
                      px: 3,
                      height: '240px',
                      borderBottom: '3px solid #247AA8',
                      position: 'relative',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: '4px',
                        background: 'linear-gradient(90deg, transparent, #247AA8, transparent)',
                        opacity: 0.5
                      }
                    }}
                  >
                    <Box
                      component="img"
                      src={extra.icon}
                      alt={extra.title}
                      sx={{
                        maxWidth: '200px',
                        maxHeight: '180px',
                        objectFit: 'contain',
                        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.15))',
                        transition: 'transform 0.3s ease',
                        '&:hover': {
                          transform: 'scale(1.1)'
                        }
                      }}
                    />
                  </Box>

                  {/* Title Button */}
                  <Box
                    sx={{
                      backgroundColor: '#247AA8',
                      color: 'white',
                      py: 2,
                      px: 3,
                      fontWeight: 600,
                      fontSize: '1.25rem',
                      textAlign: 'center'
                    }}
                  >
                    {extra.title}
                  </Box>

                  {/* Content Section */}
                  <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Subtitle */}
                    <Box sx={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          color: '#333132',
                          textAlign: 'center'
                        }}
                      >
                        {extra.subtitle}
                      </Typography>
                    </Box>

                    {/* Description */}
                    <Box sx={{ minHeight: '120px', mb: 3 }}>
                      <Typography variant="body2" sx={{ lineHeight: 1.7, color: '#333132', textAlign: 'center' }}>
                        {extra.description}
                      </Typography>
                    </Box>

                    {/* Rotating Example Image */}
                    <Box
                      onMouseEnter={() => setHoveredExtrasIndex(index)}
                      onMouseLeave={() => setHoveredExtrasIndex(null)}
                      sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease',
                        mb: 3,
                        '&:hover': {
                          transform: 'scale(1.05)'
                        }
                      }}
                    >
                      <Box
                        component="img"
                        src={extra.images[currentExtrasIndices[index]]}
                        alt={`${extra.title} example`}
                        sx={{
                          width: '100%',
                          height: 'auto',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </Box>

                    {/* More Info Button */}
                    <Box sx={{ textAlign: 'center', mt: 'auto' }}>
                      <Button
                        variant="outlined"
                        onClick={() => navigate(extra.link)}
                        sx={{
                          borderColor: '#247AA8',
                          color: '#247AA8',
                          fontWeight: 600,
                          px: 4,
                          py: 1,
                          '&:hover': {
                            borderColor: '#1E6A92',
                            backgroundColor: 'rgba(36, 122, 168, 0.05)'
                          }
                        }}
                      >
                        More Info
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Design & File Requirements */}
      <Box sx={{ py: 8, backgroundColor: '#f9f9f9' }}>
        <Container maxWidth="lg">
          <Typography variant="h3" component="h2" gutterBottom align="center" sx={{ mb: 2, fontWeight: 600, color: '#333132' }}>
            Design, Image & File Requirements
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 6, color: '#666', maxWidth: '800px', mx: 'auto' }}>
            Ensure your artwork meets our specifications for the best results
          </Typography>
          
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Paper 
                elevation={3} 
                sx={{ 
                  p: 4, 
                  height: '100%',
                  borderTop: '4px solid #247AA8',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: '#E8F4F8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 2
                    }}
                  >
                    <Typography variant="h5" sx={{ color: '#247AA8', fontWeight: 700 }}>
                      ✓
                    </Typography>
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 600, color: '#247AA8' }}>
                    Supplying Your Image Files
                  </Typography>
                </Box>
                <List sx={{ '& .MuiListItem-root': { py: 1.5, px: 0 } }}>
                  {imageFileRequirements.map((requirement, index) => (
                    <ListItem key={index}>
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: '#247AA8',
                          mr: 2,
                          flexShrink: 0
                        }}
                      />
                      <ListItemText
                        primary={requirement}
                        primaryTypographyProps={{
                          fontSize: '1rem',
                          lineHeight: 1.7,
                          color: '#333132'
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper 
                elevation={3} 
                sx={{ 
                  p: 4, 
                  height: '100%',
                  borderTop: '4px solid #247AA8',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      backgroundColor: '#E8F4F8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 2
                    }}
                  >
                    <Typography variant="h5" sx={{ color: '#247AA8', fontWeight: 700 }}>
                      📄
                    </Typography>
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 600, color: '#247AA8' }}>
                    Applications & File Formats
                  </Typography>
                </Box>
                <List sx={{ '& .MuiListItem-root': { py: 1.5, px: 0 } }}>
                  {acceptedFormats.map((format, index) => (
                    <ListItem key={index}>
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: '#247AA8',
                          mr: 2,
                          flexShrink: 0
                        }}
                      />
                      <ListItemText
                        primary={format}
                        primaryTypographyProps={{
                          fontSize: '1rem',
                          lineHeight: 1.7,
                          color: '#333132'
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>

          <Box sx={{ mt: 4 }}>
            <Box 
              sx={{ 
                backgroundColor: '#247AA8', 
                borderRadius: 2, 
                p: 3,
                textAlign: 'center'
              }}
            >
              <Typography variant="body1" sx={{ fontSize: '1.05rem', lineHeight: 1.8, color: 'white' }}>
                If you have any questions or are unsure about how to supply your artwork, please call <strong>1800 245 077</strong>. 
                We are always happy to help. <strong>Free graphic design</strong> is also included in all of our campaigns if it's required.
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ py: 4, backgroundColor: '#247AA8', color: 'white', textAlign: 'center' }}>
        <Container>
          <Typography variant="body2">
            Copyright Australian Newsletter Services Pty Ltd 2016-2024 |{' '}
            <Box
              component="a"
              href="/advertising/terms-and-conditions"
              sx={{
                color: 'white',
                textDecoration: 'underline',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8
                }
              }}
            >
              Advertising Terms & Conditions
            </Box>
            {' '}| All Rights Reserved
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            QAssure Number: 11954 | Accredited GITC Supplier: Q-6019 | ABN 24 010 367 478
          </Typography>
        </Container>
      </Box>
    </AdvertisingLayout>
  );
};

export default ArtworkSpecs;

